import { useSelector } from 'react-redux';

import type { RootState } from 'store';

import { AuthUserType } from 'common/graphql/types';

import { useQuery } from '../../hooks/useQuery';
import type { DCRConfig } from '../types/types';

import { GetDCRConfigQuery } from './queries';

export function useDCRConfig(studyId: string, siteId: string) {
    const activeUser = useSelector((state: RootState) => state.auth.activeUser);

    const shouldFetch = Boolean(studyId && activeUser?.type !== AuthUserType.PATIENT);

    const { data, isLoading } = useQuery<DCRConfig>(GetDCRConfigQuery, {
        variables: {
            input: {
                studyId,
                siteId,
            },
        },
        queryString: 'getDCRConfig',
        skip: !shouldFetch,
    });

    return {
        dcrConfig: data,
        isLoading,
    };
}
